/* ==========================================================================
   CAIXA FILOSOFAL - Medição

   O único arquivo do tema que sabe o que é `dataLayer`. Todo o resto do site
   apenas anuncia o que aconteceu, em eventos de DOM; aqui eles viram os
   eventos que o Google Tag Manager escuta.

   A separação é proposital: apagar este arquivo tira a medição inteira e não
   quebra nada — o carrinho, a gaveta e o envio para o WhatsApp continuam
   funcionando sem ele. Marketing não pode ser dependência do que converte.

   ---------------------------------------------------------------------------
   O QUE ESTE SITE NÃO TEM

   Não há preço, não há checkout e não há compra. Então:

     - nenhum evento leva `value` ou `price`. Um `value: 0` viraria receita
       zero no GA4, e receita zero parece dado — é pior que campo ausente.
     - não existe `purchase`, `begin_checkout` nem `add_payment_info` de
       verdade. O fim do funil aqui é `generate_lead`: o clique que abre o
       WhatsApp com o pedido já montado dentro.

   ---------------------------------------------------------------------------
   OS DOIS TIPOS DE LEAD

   `origem: 'gaveta'`  -> a pessoa montou um pedido, preencheu (ou não) os
                          dados e mandou. É lead com conteúdo.
   qualquer outra      -> clicou num botão solto de WhatsApp. É contato, e
                          vale muito menos.

   Os dois disparam `generate_lead`, com `cf_origem` diferente. Otimizar
   campanha pelos dois juntos infla o resultado; a separação está aqui para
   que o gestor de tráfego possa escolher.
   ========================================================================== */

(function () {
  'use strict';

  window.dataLayer = window.dataLayer || [];

  var MARCA = 'Caixa Filosofal';

  function push(dados) {
    try {
      window.dataLayer.push(dados);
    } catch (e) {}
  }

  /* O objeto `ecommerce` é persistente no dataLayer: sem limpar antes, os
     itens de um evento vazam para o seguinte e o GA4 conta produto que a
     pessoa nem viu. Recomendação do próprio Google. */
  function pushEcommerce(evento, ecommerce, extras) {
    push({ ecommerce: null });
    var dados = { event: evento, ecommerce: ecommerce };
    for (var k in extras || {}) {
      if (Object.prototype.hasOwnProperty.call(extras, k)) dados[k] = extras[k];
    }
    push(dados);
  }

  function texto(s) {
    return String(s == null ? '' : s);
  }

  /* ---------- de item de carrinho da Shopify para item de GA4 ----------

     As properties[] guardam a personalização — kit, cor, número de cards.
     Elas vão em dois lugares de propósito:

       item_variant        -> onde o GA4 espera a variação, e é onde os
                              relatórios de produto já sabem agrupar
       cf_personalizacao   -> o texto inteiro, para quem quiser ler no bruto

     As chaves iniciadas por "_" são ocultas na Shopify e ficam de fora. */

  function personalizacao(item) {
    var props = (item && item.properties) || {};
    var partes = [];
    for (var chave in props) {
      if (!Object.prototype.hasOwnProperty.call(props, chave)) continue;
      if (chave.charAt(0) === '_') continue;
      var valor = texto(props[chave]).trim();
      if (valor) partes.push(valor);
    }
    return partes.join(' · ');
  }

  function itemGA4(item, indice) {
    if (!item) return null;
    var pers = personalizacao(item);
    var ga4 = {
      item_id: item.product_id || item.id,
      item_name: item.product_title || item.title,
      item_brand: MARCA,
      item_category: item.product_type || 'Quadro personalizado',
      item_variant: pers || item.variant_title || '',
      quantity: item.quantity || 1
    };
    if (pers) ga4.cf_personalizacao = pers;
    if (item.handle) ga4.item_handle = item.handle;
    if (typeof indice === 'number') ga4.index = indice + 1;
    return ga4;
  }

  function itensDoCarrinho(cart) {
    if (!cart || !cart.items) return [];
    return cart.items.map(function (item, i) {
      return itemGA4(item, i);
    }).filter(Boolean);
  }

  /* ---------- de onde veio o clique ----------

     A Shopify embrulha cada seção em <div id="shopify-section-...__nome">.
     Ler esse id dá a origem de graça, em todas as seções, sem precisar
     marcar botão por botão — e uma seção nova nasce medida.

     Um data-cf-origem no elemento tem precedência, para os poucos casos que
     não vivem dentro de uma seção (o botão flutuante, por exemplo). */

  function origemDo(no) {
    if (!no || !no.closest) return 'geral';

    var marcado = no.closest('[data-cf-origem]');
    if (marcado) return marcado.getAttribute('data-cf-origem');

    if (no.closest('[data-cf-drawer]')) return 'gaveta';

    var secao = no.closest('.shopify-section');
    if (secao && secao.id) {
      var id = secao.id.replace('shopify-section-', '');
      var corte = id.lastIndexOf('__');
      return corte === -1 ? id : id.slice(corte + 2);
    }
    return 'geral';
  }

  /* ==========================================================================
     1. O que a gaveta de orçamento anuncia
     ========================================================================== */

  document.addEventListener('cf:pedido:adicionado', function (evento) {
    var item = itemGA4(evento.detail && evento.detail.item);
    if (!item) return;
    pushEcommerce('add_to_cart', { items: [item] });
  });

  document.addEventListener('cf:pedido:aberto', function (evento) {
    var d = evento.detail || {};
    pushEcommerce('view_cart', { items: itensDoCarrinho(d.cart) }, {
      cf_origem: d.origem || 'botao',
      cf_unidades: (d.cart && d.cart.item_count) || 0
    });
  });

  /* Aumentar quantidade é add_to_cart da diferença; diminuir e tirar são
     remove_from_cart. Mandar a quantidade CHEIA nos dois casos, que é o erro
     comum, faz o relatório contar 30 unidades adicionadas quando a pessoa
     só clicou uma vez no "+". */
  document.addEventListener('cf:pedido:alterado', function (evento) {
    var d = evento.detail || {};
    var item = itemGA4(d.item);
    if (!item) return;

    var diferenca = (d.para || 0) - (d.de || 0);
    if (diferenca === 0) return;

    item.quantity = Math.abs(diferenca);
    pushEcommerce(diferenca > 0 ? 'add_to_cart' : 'remove_from_cart', { items: [item] }, {
      cf_origem: 'gaveta'
    });
  });

  /* A conversão principal. */
  document.addEventListener('cf:pedido:enviado', function (evento) {
    var d = evento.detail || {};
    var cart = d.cart || {};
    pushEcommerce('generate_lead', { items: itensDoCarrinho(cart) }, {
      cf_origem: 'gaveta',
      cf_tipo_lead: 'pedido_montado',
      cf_unidades: cart.item_count || 0,
      cf_linhas: (cart.items && cart.items.length) || 0,
      cf_tem_dados: temDadosPreenchidos()
    });
  });

  /* ==========================================================================
     2. Preenchimento dos dados de quem pede

     É o "inserção de informação" do funil: nome, empresa, prazo e CEP na
     gaveta. Nenhum é obrigatório, então preencher é sinal forte de intenção —
     em geral o melhor sinal antes do envio.

     Dispara no `change` (ou seja, ao sair do campo), e uma única vez por
     campo. No `input` seria um evento por tecla digitada: o mesmo lead
     apareceria oitenta vezes no relatório.
     ========================================================================== */

  var camposVistos = {};

  function temDadosPreenchidos() {
    var campos = document.querySelectorAll('[data-cf-quem]');
    for (var i = 0; i < campos.length; i++) {
      if (texto(campos[i].value).trim()) return true;
    }
    return false;
  }

  document.addEventListener('change', function (evento) {
    var campo = evento.target.closest && evento.target.closest('[data-cf-quem]');
    if (!campo) return;

    var nome = campo.getAttribute('data-cf-quem');
    if (!texto(campo.value).trim()) return;
    if (camposVistos[nome]) return;
    camposVistos[nome] = true;

    /* O VALOR não vai junto, e isso não é descuido. Nome, empresa e CEP são
       dados pessoais: mandá-los para o GA4 ou para a Meta é violação de
       LGPD e, nos termos do Google, motivo de suspensão da conta. Sobe o
       nome do CAMPO, que é o que responde à pergunta do funil. */
    push({
      event: 'cf_dados_pedido',
      cf_campo: nome,
      cf_campos_preenchidos: Object.keys(camposVistos).length
    });
  });

  /* ==========================================================================
     3. Personalização escolhida na página de produto

     Kit, cor e número de cards. É o passo entre ver o produto e adicionar ao
     pedido, e é onde dá para ver qual kit as pessoas realmente querem — que
     hoje ninguém sabe.
     ========================================================================== */

  document.addEventListener('change', function (evento) {
    var campo = evento.target;
    if (!campo || !campo.name) return;
    if (campo.name.indexOf('properties[') !== 0) return;

    var rotulo = campo.name.slice('properties['.length, -1);
    if (rotulo.charAt(0) === '_') return;

    push({
      event: 'cf_personalizou',
      cf_opcao: rotulo,
      cf_valor: texto(campo.value),
      cf_origem: origemDo(campo)
    });
  });

  /* ==========================================================================
     4. Todo link de WhatsApp do site

     São nove lugares: cabeçalho, rodapé, botão flutuante, página de produto,
     página de kit, seção de orçamento, carrinho, busca e a tela de senha.
     Um ouvinte delegado cobre os nove, e cobre também o próximo que aparecer.

     O botão da gaveta fica de fora: ele é um <button> tratado por pedido.js,
     que já anuncia `cf:pedido:enviado` com o pedido inteiro. Medir os dois
     contaria a mesma conversão duas vezes.
     ========================================================================== */

  document.addEventListener('click', function (evento) {
    var alvo = evento.target.closest && evento.target.closest('a[href*="wa.me"]');
    if (!alvo) return;
    if (alvo.hasAttribute('data-cf-enviar')) return;

    var dados = {
      event: 'generate_lead',
      cf_origem: origemDo(alvo),
      cf_tipo_lead: 'contato_avulso'
    };
    /* Os cards de produto da landing page levam direto ao WhatsApp (24/09)
       e dizem qual produto foi, para o lead chegar com assunto. */
    var produto = alvo.getAttribute('data-cf-produto');
    if (produto) dados.cf_produto = produto;
    push(dados);
  });

  /* ==========================================================================
     5. Formulário de lead (o caminho de quem não quer WhatsApp na hora)
     ========================================================================== */

  document.addEventListener('submit', function (evento) {
    var form = evento.target;
    if (!form || !form.getAttribute) return;

    var acao = texto(form.getAttribute('action'));
    if (acao.indexOf('/contact') === -1) return;

    push({
      event: 'cf_form_enviado',
      cf_origem: origemDo(form),
      cf_tipo_lead: 'formulario'
    });
  });
})();
